module.exports = __webpack_public_path__ + "blue_file.abdc0799.svg";